<div class="operation-content">
  <div class="operation-controls">
    <y42-operation-input-operator-form-control
      [operatorControl]="form.controls.operator!"
      [operatorOptions]="state.operatorOptions"
    ></y42-operation-input-operator-form-control>

    <div
      *ngIf="
        form.controls.operator?.value !== OperatorEnum.In &&
        form.controls.operator?.value !== OperatorEnum.NotIn &&
        form.controls.operator?.value !== OperatorEnum.Equals &&
        form.controls.operator?.value !== OperatorEnum.IsNot &&
        form.controls.operator?.value !== OperatorEnum.IsEmpty &&
        form.controls.operator?.value !== OperatorEnum.IsNotEmpty
      "
    >
      <mat-form-field [style.fontSize]="'10px'" appearance="outline" class="w-full no-padding">
        <mat-label>Text</mat-label>
        <input
          matInput
          [ngModel]="form.controls.values.value[0]"
          (ngModelChange)="form.controls.values.patchValue([$event])"
          type="text"
          autocomplete="off"
        />
      </mat-form-field>
    </div>
    <div
      *ngIf="
        form.controls.operator?.value === OperatorEnum.In ||
        form.controls.operator?.value === OperatorEnum.NotIn ||
        form.controls.operator?.value === OperatorEnum.Equals ||
        form.controls.operator?.value === OperatorEnum.IsNot
      "
    >
      <mat-form-field [style.fontSize]="'10px'" class="w-full no-padding" appearance="outline">
        <mat-label>Search</mat-label>
        <input autocomplete="off" matInput [formControl]="searchFormControl" />
        <div matPrefix>
          <fa-icon [icon]="['fal', 'search']" class="mr-1 relative"></fa-icon>
        </div>
      </mat-form-field>

      <div
        class="w-full overflow-auto border-common"
        style="max-height: 300px; min-height: 100px"
        *ngIf="
          form.controls.operator?.value === OperatorEnum.Equals || form.controls.operator?.value === OperatorEnum.IsNot
        "
      >
        <mat-selection-list [formControl]="form.controls.values" color="primary" class="pt-0" [multiple]="false">
          <mat-list-option
            *ngFor="let value of predefinedValuesWithHidden$ | async; let i = index; trackBy: trackByValueProp"
            [hidden]="value"
            style="height: 35px"
            [value]="value"
          >
            <span class="font-normal fs-08 text-left">{{ value }}</span>
          </mat-list-option>
        </mat-selection-list>
        <div *ngIf="predefinedValues?.length === 0" class="h-full w-full font-semibold fs-1 aligner flex-col">0</div>
      </div>
      <div
        class="w-full overflow-auto border-common"
        style="max-height: 300px; min-height: 100px"
        *ngIf="
          form.controls.operator?.value === OperatorEnum.In || form.controls.operator?.value === OperatorEnum.NotIn
        "
      >
        <mat-selection-list [formControl]="form.controls.values" color="primary" class="pt-0">
          <mat-list-option
            *ngFor="let value of predefinedValuesWithHidden$ | async; let i = index; trackBy: trackByValueProp"
            [hidden]="value"
            style="height: 35px"
            [value]="value"
          >
            <span class="font-normal fs-08 text-left">{{ value }}</span>
          </mat-list-option>
        </mat-selection-list>
        <div *ngIf="predefinedValues?.length === 0" class="h-full w-full font-semibold fs-1 aligner flex-col">0</div>
      </div>
    </div>
  </div>

  <y42-operation-input-delete [index]="index" [columnType]="columnType"></y42-operation-input-delete>
</div>

<y42-operation-input-add
  [index]="index"
  [columnType]="columnType"
  [defaultOperator]="state.operatorOptions[0].value"
></y42-operation-input-add>
